// extracted by mini-css-extract-plugin
export default {"container":"ViewNotification_container__alaUs","fields":"ViewNotification_fields__ZkM6q"};